var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"white"}},[_c('Search',{staticStyle:{"margin-top":"-1rem"}}),_c('Tutorial',{staticStyle:{"margin-top":"-1rem"}}),_c('Footer',{staticStyle:{"margin-top":"-3rem"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }